import React, {createContext} from "react";
import {AuthorizationAction, AuthorizationState} from "./athorization-reducer";

const AuthorizationContext = createContext<{state: AuthorizationState, dispatch: React.Dispatch<AuthorizationAction>} | null>(null);

export default AuthorizationContext